import { FC } from 'react';

import BottleSizeListing from 'components/main/BottleSize';

const BottleSize: FC = () => <BottleSizeListing />;

export default BottleSize;
